import { render, staticRenderFns } from "./categoryevent.vue?vue&type=template&id=fe21d06a&scoped=true"
import script from "./categoryevent.vue?vue&type=script&lang=js"
export * from "./categoryevent.vue?vue&type=script&lang=js"
import style0 from "./categoryevent.vue?vue&type=style&index=0&id=fe21d06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe21d06a",
  null
  
)

export default component.exports